import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import type { UserSettings, UpdateUserSettingsInput } from "@/hooks/useUserSettings";

interface NotificationSettingsProps {
  settings: UserSettings;
  onUpdate: (updates: UpdateUserSettingsInput) => Promise<void>;
  isLoading?: boolean;
}

export function NotificationSettings({
  settings,
  onUpdate,
  isLoading = false,
}: NotificationSettingsProps) {
  const handleToggle = async (key: keyof UpdateUserSettingsInput, value: boolean) => {
    try {
      await onUpdate({ [key]: value });
    } catch (error) {
      // Error handling is done in the parent component
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label>Email Notifications</Label>
          <p className="text-sm text-muted-foreground">
            Receive notifications about your orders and account activity
          </p>
        </div>
        <Switch
          checked={settings.email_notifications}
          onCheckedChange={(checked) => handleToggle("email_notifications", checked)}
          disabled={isLoading}
        />
      </div>

      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label>Push Notifications</Label>
          <p className="text-sm text-muted-foreground">
            Receive push notifications on your devices
          </p>
        </div>
        <Switch
          checked={settings.push_notifications}
          onCheckedChange={(checked) => handleToggle("push_notifications", checked)}
          disabled={isLoading}
        />
      </div>

      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label>Marketing Emails</Label>
          <p className="text-sm text-muted-foreground">
            Receive updates about new features and promotions
          </p>
        </div>
        <Switch
          checked={settings.marketing_emails}
          onCheckedChange={(checked) => handleToggle("marketing_emails", checked)}
          disabled={isLoading}
        />
      </div>
    </div>
  );
} 